import type { FC } from 'react';
import React from 'react';

import type { BaseSvgProps } from '../../utils';
import { colorToHexCode, sizeToSvgWidth } from '../../utils';

export const HistoryB: FC<BaseSvgProps> = ({
  'data-testid': dataTestId,
  width = sizeToSvgWidth.sm,
  primaryColorHexCode = colorToHexCode.black,
}) => (
  <svg
    data-testid={dataTestId}
    width="14"
    height="27"
    className="shrink-0"
    viewBox="0 0 14 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.45752 14.9306L5.42534 14.9306L5.42534 10.8984L6.6708 10.8984L6.6708 13.6852L9.45752 13.6852L9.45752 14.9306Z"
      fill={primaryColorHexCode}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75055 19.0447C9.53662 19.0447 11.7952 16.7861 11.7952 14.0001C11.7952 11.214 9.53662 8.95543 6.75055 8.95543C3.96448 8.95543 1.70592 11.214 1.70592 14.0001C1.70592 16.7861 3.96448 19.0447 6.75055 19.0447ZM6.75055 20.3151C10.2382 20.3151 13.0655 17.4877 13.0655 14.0001C13.0655 10.5124 10.2382 7.68506 6.75055 7.68506C3.26287 7.68506 0.435547 10.5124 0.435547 14.0001C0.435547 17.4877 3.26287 20.3151 6.75055 20.3151Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
